import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentUpdateLinkAction, isLinkedDocsLockedSelector } from 'domain/documents';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import { LinkedDocumentsNotesTextarea } from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/StyledComponents';
import { useIntl } from 'react-intl';

const LinkedNote = ({ note, linkID }) => {
  const dispatch = useDispatch();
  const isLocked = useSelector(isLinkedDocsLockedSelector);
  const { formatMessage } = useIntl();
  const [value, setValue] = useState(note);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onBlur = () => {
    if (note !== value) {
      dispatch(documentUpdateLinkAction({ text: value, linkID }));
    }
  };

  useEffect(() => {
    setValue(note);
  }, [note]);

  return (
    <Box mb={2}>
      <InputLabel htmlFor="linkedNoteField" sx={{ mb: 1, color: 'text.primary', fontWeight: 500 }}>
        {formatMessage({
          id: 'documents.linkedPanel.note.label',
          defaultMessage: 'Notes',
        })}
      </InputLabel>
      <LinkedDocumentsNotesTextarea
        id="linkedNoteField"
        multiline
        fullWidth
        variant="filled"
        rows={4}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={isLocked}
        placeholder={formatMessage({
          id: 'documents.linkedPanel.note.placeholder',
          defaultMessage: 'Type your note here',
        })}
      />
    </Box>
  );
};

export default LinkedNote;
